import { render, staticRenderFns } from "./DetailCell.vue?vue&type=template&id=6d684310&scoped=true&"
import script from "./DetailCell.vue?vue&type=script&lang=js&"
export * from "./DetailCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d684310",
  null
  
)

export default component.exports